import axios from "axios";
import liquidations from "../../models/liquidaciones/liquidations";
import details from "../../models/liquidaciones/details";
import signature from "../../models/liquidaciones/signature";
import salary from "../../models/liquidaciones/salary";
import liquidation from "../../store/liquidaciones/liquidation";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLiquidation() {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/liquidaciones/${operId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return liquidations.fromJson(item);
        });
      });
  }
  signature(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      operId: operId,
      liqId: data.id,
    };
    return axios.post(`${url}/liquidaciones/firmarliq`, payload, { headers });
  }
  removeSignature(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      operId: operId,
      liqId: data.id,
    };
    return axios.post(`${url}/liquidaciones/retirarfirmarliq`, payload, {
      headers,
    });
  }
  generateSalaryInterface(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      operId: operId,
      liqId: data.id,
    };
    return axios.post(`${url}/liquidaciones/liqsueldos`, payload, { headers });
  }
  changeState(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      operId: operId,
      liqId: data.id,
    };
    return axios.post(`${url}/liquidaciones/cambiarestado`, payload, {
      headers,
    });
  }
  getDetails(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/liquidaciones/detalle/${data.id}?liqid=${data.id}`, {
        headers,
      })
      .then(({ data }) => {
        if (data.length > 0) {
          const firstRow = data[0];
          const headers = Object.keys(firstRow);
          liquidation.commit("setHeaders", headers);

          const convertedRows = data.map((item) => {
            return details.fromJson(item);
          });
          liquidation.commit("setRows", convertedRows);
        }
        return data.map((item) => {
          return details.fromJson(item);
        });
      });
  }
  getSalary(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/liquidaciones/csueldos/${data.id}?liqid=${data.id}`, {
        headers,
      })
      .then((response) => {
        const responseData = response.data;
        if (responseData.length > 0) {
          const firstRow = responseData[0];
          const headers = Object.keys(firstRow);
          liquidation.commit("setHeaders", headers);

          const convertedRows = responseData.map((item) => {
            return salary.fromJson(item);
          });

          liquidation.commit("setRows", convertedRows);
          return convertedRows;
        }
        return [];
      })
      .catch(() => {
        return [];
      });
  }

  getSignature(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/liquidaciones/firmas/${data.id}?liqid=${data.id}`, {
        headers,
      })
      .then(({ data }) => {
        if (data.length > 0) {
          const firstRow = data[0];
          const headers = Object.keys(firstRow);
          liquidation.commit("setHeaders", headers);
          const convertedRows = data?.map((item) => {
            return signature.fromJson(item);
          });
          liquidation.commit("setRows", convertedRows);
        }

        return data.map((item) => {
          return signature.fromJson(item);
        });
      });
  }
}
export default service;
